export const isLikelyEmail = (value?: string): boolean => {
  const normalized = value?.trim();
  if (!normalized || normalized.includes(" ")) {
    return false;
  }
  const parts = normalized.split("@");
  if (parts.length !== 2) {
    return false;
  }
  const [localPart, domainPart] = parts;
  if (!localPart || !domainPart) {
    return false;
  }
  if (domainPart.startsWith(".") || domainPart.endsWith(".")) {
    return false;
  }
  if (!domainPart.includes(".")) {
    return false;
  }
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(normalized);
};
